export const unitDates = {
  years: "years",
  year: "year",
  months: "months",
  month: "month",
  weeks: "weeks",
  week: "week",
  days: "days",
  day: "day",
  hours: "hours",
  hour: "hour",
  minutes: "minutes",
  minute: "minute",
  seconds: "seconds",
  second: "second",
  milliseconds: "milliseconds",
  millisecond: "millisecond",
};

export const shortUnitDates = {
  y: "y",
  M: "M",
  w: "w",
  d: "d",
  h: "h",
  m: "m",
  s: "s",
  ms: "ms",
};


export const unicodeTokens = [
  {
    moment:'dddd',
    datefns: 'eeee'
  },
  {
    moment:'DD',
    datefns: 'dd'
  },
  {
    moment:'D',
    datefns: 'd'
  },
  {
    moment:'YYYY',
    datefns: 'yyyy'
  },
  {
    moment:'YY',
    datefns: 'yy'
  },
  {
    moment:'Y',
    datefns: 'y'
  }
];



// WEBPACK FOOTER //
// ./src/packages/dates/lib/unitDates.js